import { Injectable, inject } from '@angular/core';
import { GoogleAuthApi } from '../apis/google-auth-apis';
import { GoogleAuthToken } from '../interfaces/google-auth-token';
declare var google: any;
@Injectable({
  providedIn: 'root',
})
export class GoogleAuthService {
  private googleAuthApi = inject(GoogleAuthApi);

  async authenticateWithGoogle(token: GoogleAuthToken, scopeType: string) {
    return await this.googleAuthApi.activateToken(token, scopeType);
  }

  logout(scope: string, email: string = '') {
    return this.googleAuthApi.logout(scope, email);
  }

  getClientId(scopeName: string = 'calendar') {
    return this.googleAuthApi.getClientId(scopeName);
  }

  async login(
    scopeType: string = 'error',
    scope: string,
    scopeName: string,
    emailHint?: string[],
  ): Promise<any> {
    return new Promise(async (resolve, reject) => {
      let clientId = await this.getClientId(scopeName);
      var tokenClient = google.accounts.oauth2.initCodeClient({
        client_id: clientId,
        scope: scope,
        hints: emailHint ? emailHint : undefined,
        callback: async (tokenResponse: GoogleAuthToken) => {
          try {
            const res = await this.authenticateWithGoogle(
              tokenResponse,
              scopeType,
            );
            resolve(res);
          } catch (error) {
            reject(error);
          }
        },
      });
      tokenClient.requestCode();
    });
  }
}
